import React, { Component } from 'react';

class Ads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };
  }

  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    return (
      <div>
        <ins className="adsbygoogle"
             style={{'display': 'block'}}
             data-ad-client="ca-pub-6140177519808277"
             data-ad-slot="6203462730"
             data-ad-format="auto"></ins>
      </div>
    );
  }
}

export default Ads;



// WEBPACK FOOTER //
// ./src/components/Ads/Ads.js